module.exports = __webpack_public_path__ + "static/media/october2024-5.325125d4.webp";